import React,{useEffect, useState} from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { api } from '../config/api';
import { showSuccess, showError } from '../utils/toast';
import { getApiErrorMessage } from '../utils/apiError';

function AdminUpdateClient({ embedded = false, onClose, onSuccess, modalPayload }) {
    let navigate = useNavigate();
    const { id: routeId } = useParams();
    const id = embedded && modalPayload?.id ? modalPayload.id : routeId;
    const [values,setValues]= useState({
  id:id,
  ClientName:'',
  ClientCode:'',
  Email:'',
  Email1:'',
  Email2:'', 
  Location:'',
  MobileNumber:'',
  MobileNumber1:'',
  MobileNumber2:'',
  Name:'',
  Name1:'',
  Name2:'',
  Services:'',
  Spoc:'',
  Spoc1:'',
  Spoc2:'',

})
useEffect(()=>{
    if (!id) return;
    api.get(`/getClientdatatoUpdate/${id}`)
.then(res=>{
  setValues({
    id,
    ClientName:res.data.ClientName,
    ClientCode:res.data.ClientCode,
    Email:res.data.Email,
    Email1:res.data.Email1,
    Email2:res.data.Email2,
    Location:res.data.Location,
    MobileNumber:res.data.MobileNumber,
    MobileNumber1:res.data.MobileNumber1,
    MobileNumber2:res.data.MobileNumber2,
    Name:res.data.Name,
    Name1:res.data.Name1,
    Name2:res.data.Name2,
    Services:res.data.Services,
    Spoc:res.data.Spoc,
    Spoc1:res.data.Spoc1,
    Spoc2:res.data.Spoc2,
  });
}).catch(err=> console.log(err))
},[id])

const handleSubmit= async (e)=>{
    e.preventDefault();
    api.put(`/UpdateClient/${id}`, values)
    .then(res=>{
     if (embedded && onSuccess) onSuccess(res.data.msg || 'Client updated successfully');
     else if (embedded && onClose) onClose();
     else {
       showSuccess(res.data.msg || 'Client updated successfully ✓');
       navigate('/clients/list');
     }
    }).catch(err=> { console.log(err); showError(getApiErrorMessage(err, 'Error updating client. Please try again.'));})    
 }
  return (
    <div className={embedded ? 'hr-embedded-form' : ''}>
        <center>
        <Form id="edit-client-form" onSubmit={handleSubmit} style={embedded ? {} : {backgroundColor:"antiquewhite",margin:"15px",borderRadius:"20px",padding:"20px"}}>
         {!embedded && (
         <>
         <h2 style={{textAlign:"center",fontFamily:"initial"}}><b><img style={{width:"35px",borderRadius:"50px"}} src="/Images/icon.png" alt="" /> Update Client Details</b></h2> <hr></hr>
         </>
         )}
        <Row className="mb-3">
        <Form.Group as={Col} >
          <Form.Label style={{margin:"10px"}}><b>Client Code</b></Form.Label>
          <Form.Control   value={values.ClientCode} onChange={(e) => setValues({...values,ClientCode:e.target.value})} style={{width:"300px",borderRadius:"15px",border:"1px solid black"}} />
                </Form.Group>

        <Form.Group as={Col} >
          <Form.Label style={{margin:"10px"}}><b>Client Name</b></Form.Label>
          <Form.Control   value={values.ClientName} onChange={(e) => setValues({...values,ClientName:e.target.value})} style={{width:"300px",borderRadius:"15px",border:"1px solid black"}} placeholder="Client Name" />
                   </Form.Group>
        <Form.Group as={Col} >
          <Form.Label style={{margin:"10px"}} title='Types Of Services'><b>Type Of Services</b></Form.Label>
          <Form.Select  value={values.Services} onChange={(e)=> setValues({...values,Services:e.target.value})} style={{width:"300px",textAlign:"center",border:"1px solid black",borderRadius:"15px"}} >
            <option value="">Choose...</option>
            <option value="FTE">FTE</option>
            <option value="TP">TP</option>
            <option value="FTE & TP">Both</option>

          </Form.Select>
        
        </Form.Group>
        <Form.Group as={Col} >
          <Form.Label style={{margin:"10px"}}><b>Location</b></Form.Label>
          <Form.Control   value={values.Location} onChange={(e) => setValues({...values,Location:e.target.value})} style={{width:"300px",borderRadius:"15px",border:"1px solid black"}} placeholder="Location" />
                    </Form.Group> <hr style={{marginTop:"20px"}}></hr>
<center>              <h5 style={{fontFamily:"fantasy",textDecoration:"underline"}}><b>Contact Details</b></h5>
</center>      
  <Form.Group as={Col} >
          <Form.Label style={{margin:"10px"}}><b>1<sup>st</sup> <sub>Contact Person Name</sub></b></Form.Label>
          <Form.Control   value={values.Name} onChange={(e) => setValues({...values,Name:e.target.value})} style={{width:"300px",borderRadius:"15px",border:"1px solid black"}} placeholder="Name" />
                    </Form.Group>
              <Form.Group as={Col} >
          <Form.Label style={{margin:"10px"}}><b>Type Of Contact</b></Form.Label>
          <Form.Control  value={values.Spoc} onChange={(e) => setValues({...values,Spoc:e.target.value})} style={{width:"300px",borderRadius:"15px",border:"1px solid black"}} placeholder="Type Of Contact" />
            
                  </Form.Group>
        <Form.Group as={Col} >
          
          <Form.Label style={{margin:"10px"}}><b>Mobile Number</b></Form.Label>
          <Form.Control   value={values.MobileNumber} onChange={(e) => setValues({...values,MobileNumber:e.target.value})} style={{width:"300px",borderRadius:"15px",border:"1px solid black"}} placeholder="Mobile Number" />
                  </Form.Group>
        <Form.Group as={Col} >
          <Form.Label style={{margin:"10px"}}><b>Email ID</b></Form.Label>
          <Form.Control  value={values.Email} onChange={(e) => setValues({...values,Email:e.target.value})} style={{width:"300px",borderRadius:"15px",border:"1px solid black"}} placeholder="Email" />
          
              </Form.Group>
              <Form.Group as={Col} >
          <Form.Label style={{margin:"10px"}}><b>2<sup>nd</sup> <sub>Contact Person Name</sub> </b></Form.Label>
          <Form.Control  value={values.Name1}   onChange={(e) => setValues({...values,Name1:e.target.value})} style={{width:"300px",borderRadius:"15px",border:"1px solid black"}} placeholder="Name" />
                 </Form.Group>
              <Form.Group as={Col} >
          <Form.Label style={{margin:"10px"}}><b>Type Of Contact</b></Form.Label>
          <Form.Control  value={values.Spoc1} onChange={(e) => setValues({...values,Spoc1:e.target.value})} style={{width:"300px",borderRadius:"15px",border:"1px solid black"}} placeholder="Type Of Contact" />
            
               </Form.Group>
        <Form.Group as={Col} >
          
          <Form.Label style={{margin:"10px"}}><b>Mobile Number</b></Form.Label>
          <Form.Control  value={values.MobileNumber1} onChange={(e) => setValues({...values,MobileNumber1:e.target.value})} style={{width:"300px",borderRadius:"15px",border:"1px solid black"}} placeholder="Mobile Number" />
                  </Form.Group>
        <Form.Group as={Col} >
          <Form.Label style={{margin:"10px"}}><b>Email ID</b></Form.Label>
          <Form.Control  value={values.Email1} onChange={(e) =>setValues({...values,Email1:e.target.value})} style={{width:"300px",borderRadius:"15px",border:"1px solid black"}} placeholder="Email" />
         
              </Form.Group>
              <Form.Group as={Col} >
          <Form.Label style={{margin:"10px"}}><b>3<sup>rd</sup> <sub>Contact Person Name</sub></b></Form.Label>
          <Form.Control   value={values.Name2} onChange={(e) => setValues({...values,Name2:e.target.value})} style={{width:"300px",borderRadius:"15px",border:"1px solid black"}} placeholder="Name" />
                </Form.Group>
              <Form.Group as={Col} >
          <Form.Label style={{margin:"10px"}}><b>Type Of Contact</b></Form.Label>
          <Form.Control  value={values.Spoc2} onChange={(e) => setValues({...values,Spoc2:e.target.value})} style={{width:"300px",borderRadius:"15px",border:"1px solid black"}} placeholder="Type Of Contact" />
            
                   </Form.Group>
        <Form.Group as={Col} >
          
          <Form.Label style={{margin:"10px"}}><b>Mobile Number</b></Form.Label>
          <Form.Control   value={values.MobileNumber2} onChange={(e) => setValues({...values,MobileNumber2:e.target.value})} style={{width:"300px",borderRadius:"15px",border:"1px solid black"}} placeholder="Mobile Number" />
                   </Form.Group>
        <Form.Group as={Col} >
          <Form.Label style={{margin:"10px"}}><b>Email ID</b></Form.Label>
          <Form.Control   value={values.Email2} onChange={(e) => setValues({...values,Email2:e.target.value})} style={{width:"300px",borderRadius:"15px",border:"1px solid black"}} placeholder="Email" />
        
              </Form.Group>
       
</Row>
{!embedded && (
<center>
<Button style={{borderRadius:"15px"}} variant="primary" type="submit">
        <b>Update</b>
      </Button>
</center>
)}
</Form>
        </center>
    </div>
  )
}

export default AdminUpdateClient
